export type OfflineScopeSession = {
  managerId: number;
  managerLabel: string;
};

export const OFFLINE_SCOPE_CHANGED_EVENT = 'lidea-offline-scope-changed';

const SESSION_KEY = 'lidea.offline_scope_session';

function notifyOfflineScopeChanged() {
  window.dispatchEvent(new Event(OFFLINE_SCOPE_CHANGED_EVENT));
}

export function getOfflineScopeSession(): OfflineScopeSession | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw) as OfflineScopeSession;
  } catch {
    return null;
  }
}

export function setOfflineScopeSession(scope: OfflineScopeSession): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(scope));
  notifyOfflineScopeChanged();
}

export function clearOfflineScopeSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
  notifyOfflineScopeChanged();
}
